import { render, staticRenderFns } from "./globalPage.vue?vue&type=template&id=282b17a8&scoped=true&"
import script from "./globalPage.vue?vue&type=script&lang=js&"
export * from "./globalPage.vue?vue&type=script&lang=js&"
import style0 from "./globalPage.vue?vue&type=style&index=0&id=282b17a8&lang=scss&scoped=true&"
import style1 from "./globalPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b17a8",
  null
  
)

export default component.exports